import { Component,  Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'aff-hospitals-panel',
  templateUrl: './aff-hospitals.component.html',
  styleUrls: ['./aff-hospitals.component.css']
})
export class AffHospitalsComponent {

  @Input() header = "";
  @Input() collapsed = false;
  @Output() collapsedChange: EventEmitter<boolean>;
  @Input() visible = false;
  @Input() items = null;


  constructor() {
    this.collapsedChange = new EventEmitter<boolean>();
  }

  onClick() {
    this.collapsedChange.emit(!this.collapsed);
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/panels/aff-hospitals/aff-hospitals.component.ts